
import { Component, Prop, Vue } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";

@Component({
  components: { LogTable },
})

export default class NonTransferableLogsTab extends Vue {

  @Prop({ default: null })
  public nonTransferableId: number;

  private logs: any = [];
  private loading: boolean = false;

  private getLogs(params?: any) {
    if (this.nonTransferableId) {
      this.loading = true;
      this.$store.dispatch("logs/getLogs", {
        query: {
          currentPage: "nonTransferable",
          entityId: this.nonTransferableId,
          entityType: "nonTransferable",
          ...params,
        },
      }).then((res) => {
        this.logs = res;
      }).finally(() => {
        this.loading = false;
        this.$emit("loaded");
      });
    }
  }
}
